import { sdkRequest } from '@eb/http';

export const PASSWORDLESS_LOGIN = '/api/v3/auth/passwordless_login/';
export const PASSWORDLESS_SET_PASSWORD =
    '/api/v3/auth/create_user_password_from_passwordless_token/';

export const passwordlessLogin = ({
    internal_token,
    accepted_tos_by_popup,
}) => {
    return sdkRequest(PASSWORDLESS_LOGIN, {
        method: 'POST',
        body: JSON.stringify({
            internal_token,
            accepted_tos_by_popup,
        }),
    })
        .then((response) => response)
        .catch((error) => {
            const statusCode = error.response ? error.response.status : 400;
            if (statusCode === 200) {
                // 200 Code It's Ok
                return Promise.resolve();
            } else {
                throw error;
            }
        });
};

// It's still uncertain if we are going to use a new api or the previous one for set password, so this may change
export const passwordlessSetPassword = ({
    internal_token,
    accepted_tos_by_popup,
    password,
}) => {
    return sdkRequest(PASSWORDLESS_SET_PASSWORD, {
        method: 'POST',
        body: JSON.stringify({
            internal_token,
            accepted_tos_by_popup,
            password,
        }),
    })
        .then((response) => response)
        .catch((error) => {
            const statusCode = error.response ? error.response.status : 400;
            if (statusCode === 200) {
                // 200 Code It's Ok
                return Promise.resolve();
            } else {
                throw error;
            }
        });
};
